export const generateUniqueId = (prefixName: string): string => {
  return `${prefixName}-${Math.random().toString(36).slice(7)}`;
};

export const hasShadowDom = (el: HTMLElement) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return !!el.shadowRoot && !!(el as any).attachShadow;
};

export const renderHiddenInput = (
  always: boolean,
  container: HTMLElement,
  name: string,
  value: string | undefined | null,
  disabled: boolean,
) => {
  if (always || hasShadowDom(container)) {
    let input = container.querySelector('input.aux-input') as HTMLInputElement | null;
    if (!input) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      input = container.ownerDocument!.createElement('input');
      input.type = 'hidden';
      input.classList.add('aux-input');
      container.append(input);
    }
    input.disabled = disabled;
    input.name = name;
    input.value = value || '';
  }
};

/**
 * A helper function that lets you halt a function's execution by a given time.
 * Has to be awaited to actually do anything.
 *
 * **NOTE:** using this halts the current process, so you should be careful where you use this.
 * Make sure the process is not blocking the main thread unless you really need it to.
 *
 * @param timeout in milliseconds
 * @returns a promise which you can await
 *
 * @example
 * // ratelimited loop
 * while (true) {
 *   doSomething();
 *   await wait(500);
 * };
 */
export const wait = async (timeout: number) => {
  return new Promise<void>((resolve) => setTimeout(() => resolve(), timeout));
};
